import React, { useState, useMemo, useCallback, } from 'react';
import Panel from './Panel';
const Collapse = ({ noPadding, defaultActive = [], activeTabKeys, accordion, expandIcon, onChange, children, }) => {
    const [currentActiveTabKeys, setCurrentActiveTabKeys] = useState(() => {
        const defaultActiveTabs = accordion
            ? defaultActive.slice(0, 1)
            : defaultActive;
        return defaultActive.length ? defaultActiveTabs : [];
    });
    const getActiveTabs = useCallback((prevTabs, newTabKey) => {
        if (accordion) {
            return prevTabs.includes(newTabKey) ? [] : [newTabKey];
        }
        return prevTabs.includes(newTabKey)
            ? prevTabs.filter(prevTabKey => prevTabKey !== newTabKey)
            : [...prevTabs, newTabKey];
    }, [accordion]);
    const updateActiveTab = useCallback(newTabKey => {
        if (activeTabKeys) {
            if (onChange)
                onChange(getActiveTabs(activeTabKeys, newTabKey));
        }
        else {
            setCurrentActiveTabKeys(prevTabs => getActiveTabs(prevTabs, newTabKey));
        }
    }, [activeTabKeys, onChange, getActiveTabs]);
    const onClickPanel = useCallback((e, panelKey) => {
        updateActiveTab(panelKey);
    }, [updateActiveTab]);
    const getNewChild = useCallback((child) => {
        if (Array.isArray(child))
            return getNewChild(child);
        const { panelKey } = child.props;
        const isActive = activeTabKeys
            ? activeTabKeys.includes(panelKey)
            : currentActiveTabKeys.includes(panelKey);
        const controlledProp = {
            panelKey,
            isActive,
            expandIcon,
            onClickPanel,
            noPadding,
        };
        return React.cloneElement(child, controlledProp);
    }, [activeTabKeys, currentActiveTabKeys, expandIcon, noPadding, onClickPanel]);
    const panels = useMemo(() => {
        return React.Children.map(children, getNewChild);
    }, [children, getNewChild]);
    return React.createElement("div", null, panels);
};
Collapse.Panel = Panel;
export default Collapse;
//# sourceMappingURL=index.js.map